import React from 'react'

const LandingImg = ({ src, border, borderRadius, onLoad }) => {
  return (
    <img
      src={src}
      alt=""
      onLoad={onLoad}
      style={{
        width: "100%",
        maxWidth: "860px",
        display: "block",
        margin: "0 auto",
        border: border || "none",
        borderRadius: borderRadius || 0,
      }}
    />
  );
};

export default LandingImg;